// (copied from tvl-results cloud-functions project)
export function parseResultStringToNumber(result: string) {
    const map = {
        original: result,
        main: 0,
        sub: 0
    }

    if (result === '') {
        return 0
    }

    if (map.original.includes(':')) {
        const split: string[] = map.original.split(":")
        map.main += Number(split[0]) * 60 /*transform minutes to second*/
        map.original = split[1]
    }

    if (result.includes('.')) {
        const split = map.original.split(".")
        map.main += Number(split[0])
        map.sub += Number(split[1])
    } else if (result.includes(',')) {
        // Comma: legacy. In cloud functions, commas are replaced by dots since July 2025.
        // But DB is not migrated, therefore only new results contains dots instead of commas.
        const split = map.original.split(",")
        map.main += Number(split[0])
        map.sub += Number(split[1])
    }

    return map.main + (map.sub / 100)
}

/**
 * A function that defines the sort order.
 * The return value should be a number whose sign indicates the relative order of the two elements:
 * - negative if a is less than b,
 * - positive if a is greater than b,
 * - and zero if they are equal
 * @param {Result} a
 * @param {Result} b
 */
export function compareResults(a: Result, b: Result): number {
    let comparisonResult = 0
    let comparisonFactor = 1
    let minMaxFunction = Math.max
    let invalidResultConstant = 0

    // checks if the DisciplineGroup contains a number (e.g. 11H or 1K0)
    // if so, it's probably a run and a smaller number is a better result
    // -> change the order with multiplying it with -1
    // -> use the highest number in result-list
    // -> set a small number as alternative to ensure the value is at the end of the list (e.g. 'aufg.', 'DNS', 'n.a' etc)
    if (/\d/.test(a.disciplineGroup)) {
        comparisonFactor = -1
        minMaxFunction = Math.min
        invalidResultConstant = 1_000_000
    }

    // select the best result
    let resultA: number = a.resultValues?.length ? minMaxFunction(...a.resultValues) : 0
    let resultB: number = b.resultValues?.length ? minMaxFunction(...b.resultValues) : 0

    //replace zero values (for example if the result would be "DNS" or "aufg." with a constant, depending on if it's a run or not)
    resultA = resultA === 0 ? invalidResultConstant : resultA
    resultB = resultB === 0 ? invalidResultConstant : resultB

    if (resultB > resultA) {
        comparisonResult = 1
    } else if (resultA > resultB) {
        comparisonResult = -1
    }

    // change order with multiplying with -1 if it's a run
    return comparisonResult * comparisonFactor
}

/**
 * Returns true iff result A is better than result B
 * Return false iff result A and B are equal or result A is worse than result B
 * @param {Result} resultA
 * @param {Result} resultB
 * @return {boolean} True if result A is better than result B, false otherwise
 */
export function isBetterThan(resultA: Result, resultB: Result): boolean {
    return compareResults(resultA, resultA) > 0
}
